<template>
	<div class="My">
		<div class="my-bg" :style="{backgroundImage: `url(${userInfo.userBg})`}">
			<div><van-uploader class="uploader-box" :after-read="upload" /></div>
		</div>
		<div class="my-content" v-if="isLogin">
			<div class="my-box" >
				<div class="my-img">
					<div class="img-box">
						<img class="auto-img" :src="userInfo.userImg" alt="">
						<van-uploader class="uploader-box-two" :after-read="uploadUserImg" />
					</div>
					<div class="my-info">
						<div class="nickname">{{userInfo.nickName}}</div>
						<div class="desc">{{userInfo.desc == '' ? '这个家伙很懒，什么东西都没有留下' : userInfo.desc}}</div>					
					</div>
				</div>
			</div>
		</div>
		
		<div @click="goLogin" v-else class="not-login">
			<span>未登录,<br/>请先登陆</span>
		</div>
		
		<div class="info-box">
			<van-grid>
			  <van-grid-item icon="gold-coin" text="钱包"  />
			  <van-grid-item icon="vip-card" text="成为VIP" />
			  <van-grid-item icon="coupon" text="优惠卷" />
			  <van-grid-item icon="gift-card" text="礼品卡" />
			</van-grid>
		</div>
		<div class="info-box">
			<van-cell is-link size="large" :to="item.to" :title="item.title" v-for="(item,index) in lists" :key="index" />
		</div>
		
	</div>
</template>

<script>
	import '../assets/less/my.less'
	import {utils} from '../assets/js/utils'
	export default{
		data(){
			return{
				lists:[
					{title:'个人资料', to: {name: 'Acount'}},
					{title:'我的订单', to: {name: 'CheckOrder'}},
					{title:'我的收藏', to: {name: 'Like'}},
					{title:'收货地址', to: {name: 'MyAddress'}},
					{title:'安全中心', to: {name: 'Secure'}}
				],
				isLogin: false,
				userInfo:{},
				maxSize: 1 * 1024 * 1024
			}
		},
		created() {
			this.getUserInfo();
		},
		
		methods:{
			
			//前往登陆
			goLogin(){
				this.$router.push({name: "Login"});
			},
			
			//查询用户信息
			getUserInfo(){
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					method: 'GET',
					url: '/findMy',
					params:{
						appkey: this.appkey,
						tokenString,
					}
				}).then(result =>{
					this.$toast.clear();
					if(result.data.code == 'A001'){
						if(result.data.result.length > 0){
							this.isLogin = true;
							this.userInfo = result.data.result[0];
						}
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
			//上传背景
			upload(file){
				
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				//获取文件类型
				let type = file.file.type.split('/')[1];
				let imgType = ['png','gif','jpg','jpeg'];
				if(imgType.indexOf(type) === -1){
					this.$notify({
						message: '图片类型只支持' + imgType.join(','),
						color: '#fff',
						background: '#212572',
					})
					
				return;	
				}
				
				if(this.maxSize < file.file.size){
					this.$notify({
						message: '上传文件大小不能超过' + this.maxSize / 1024 + 'KB',
						color: '#fff',
						background: '#212572',
					})
					return;
				}
					let base64 = file.content.replace(/data:image\/[A-Za-z]+;base64,/,'')
				
				// 参数序列化
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					imgType: type,
					serverBase64Img: base64
				})
				
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})
				
				this.axios({
					method: 'POST',
					url: '/updateUserBg',
					data
				}).then(result =>{
					this.$toast.clear();
					if(result.data.code == 'I001'){
						this.userInfo.userBg = result.data.userBg;
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
			
			//上传头像
			uploadUserImg(file){
				
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if(!tokenString){
					return;
				}
				
				//获取文件类型
				let type = file.file.type.split('/')[1];
				let imgType = ['png','gif','jpg','jpeg'];
				if(imgType.indexOf(type) === -1){
					this.$notify({
						message: '图片类型只支持' + imgType.join(','),
						color: '#fff',
						background: '#212572',
					})
					
				return;	
				}
				
				if(this.maxSize < file.file.size){
					this.$notify({
						message: '上传文件大小不能超过' + this.maxSize / 1024 + 'KB',
						color: '#fff',
						background: '#212572',
					})
					return;
				}
					let base64 = file.content.replace(/data:image\/[A-Za-z]+;base64,/,'')
				
				// 参数序列化
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					imgType: type,
					serverBase64Img: base64
				})
				
				this.axios({
					method: 'POST',
					url: '/updateAvatar',
					data
				}).then(result =>{
					this.$toast.clear();
					if(result.data.code == "H001"){
						this.userInfo.userImg = result.data.userImg;
					}
				}).catch(err =>{
					this.$toast.clear();
				})
			},
			
		}
	}
</script>

<style lang="less" scoped>
</style>
